import styled from 'styled-components'

import { applyButtonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const PositiveButtonStyled = styled(BaseButton)`
  ${(props) =>
    applyButtonColorCSS(
      props.theme.colors.button.approve.background,
      undefined,
      undefined,
      props.theme.colors.button.approve.backgroundHover
    )}
`
